import classNames from "classnames";
import { RichText } from "components/RichTextWidget";
import {
  Action,
  Container,
  Icon,
  ImageLite,
  ModalWrapper,
  YoutubeVideo,
} from "shared/components";
import { useToggle } from "shared/hooks";
import { parseYouTubeId } from "shared/utils";

import styles from "./Content059.module.scss";

export const Content059 = ({ payload }) => {
  const description = payload?.description ?? "";
  const image = payload?.preview ?? {};
  const videoLink = payload?.videoLink ?? null;
  const template = payload?.template ?? "light";

  const videoId = parseYouTubeId(videoLink);

  const { opened, onOpen, onClose } = useToggle();

  return (
    <div className={classNames(styles.wrapper, styles[template])}>
      <Container>
        <div className={styles.block}>
          <ImageLite image={image} className={styles.image} />
          <div className={styles.content}>
            {videoId && (
              <Action onClick={onOpen} className={styles.play}>
                <span className={styles.arrow}>
                  <Icon className={styles.icon} name="play" theme="white" />
                </span>
              </Action>
            )}
            <RichText
              value={description}
              color="light"
              className={styles.description}
            />
          </div>

          {opened && (
            <ModalWrapper onCloseModal={onClose} appearance="full-area">
              <YoutubeVideo id={videoId} />
            </ModalWrapper>
          )}
        </div>
      </Container>
    </div>
  );
};

export default Content059;
